/**
 * @module app.bdc.cpi.cpiCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    moment.locale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_')
    });

    function CPICtrl($rootScope, $scope, cpiService, Notification, $log, pricesService, reportRoutingService) {
        var self = {};

        self.order = $rootScope.order;
        if (!self.order) {
            return $scope.goTo('/bdc/list');
        }

        self.isCreation = !self.order.cpi;
        self.isTobaccoSoftWare = self.order.options.find(o => o.code === 'LOGICIEL_CAISSE_TABAC');
        self.unknowCodeDebit = false

        if (!self.order.cpi) {
            self.order.cpi = cpiService.getCPIObject();
            self.cpi = self.order.cpi;
        }
        else {
            self.cpi = $rootScope.cpi;
        }

        pricesService.setOrderForm($rootScope.orderForm);
        pricesService.setOrder(self.order);

        self.suppliers = cpiService.suppliers;
        self.supplier = null;

        self.formations = [
            {
                id: 'rds',
                label : 'RDS',
                selected : false
            },
            {
                id: 'service',
                label : 'Service formation',
                selected: true
            }
        ];

        self.accessType = [
            {id: 'socket', label: 'Prise RJ45 murale'},
            {id: 'cable', label: 'Câble RJ45 volant'},
            {id: 'wifi', label: 'Wifi'}
        ];

        self.distances = [
            {id: '0', label: '0 à 5 mètres'},
            {id: '5', label: '5 à 10 mètres'},
            {id: '10', label: '10 à 15 mètres'},
            {id: '15', label: 'Plus de 15 mètres'}
        ];

        function initFormation(){
            self.formations.map(f => {
                f.selected = f.id === self.cpi.formation;
                if(!self.cpi.formation){
                    if(f.id === 'service')
                        f.selected = true;
                }
            });
        }

        initFormation();

        self.cpi.wishedInstallationMoment = self.cpi.wishedInstallationMoment
            ? self.cpi.wishedInstallationMoment
            : 'matin';
        self.cpi.wishedPreVisitDate = self.cpi.wishedPreVisitDate ? moment(self.cpi.wishedPreVisitDate).toDate() : null;
        self.cpi.wishedInstallationDate = self.cpi.wishedInstallationDate
            ? moment(self.cpi.wishedInstallationDate).toDate()
            : moment(self.order.dateInstallation).toDate();

        if (self.cpi.dateEndWorks) {
            self.cpi.dateEndWorks = moment(self.cpi.dateEndWorks).toDate();
        }

        self.isDatePickerInstallationOpened = false;
        self.datePickerInstallation = {
            datepickerMode: 'day',
            maxMode: 'day',
            minMode: 'day',
            minDate: moment().toDate()
        };

        self.isDatePickerPreVisitOpened = false;
        self.datePickerPreVisit = {
            datepickerMode: 'day',
            maxMode: 'day',
            minMode: 'day',
            minDate: moment().toDate()
        };

        self.getActiveModuleForDilicom = () => {
            const mods = self.order.options.filter(opt => opt.label === 'LIBRAIRIE');
            return mods.length > 0;
        }

        /**
         * Toggle the display of the installationDate's datepicker
         */
        self.toggleDateInstallation = function toggleDateInstallation() {
            self.isDatePickerInstallationOpened = !self.isDatePickerInstallationOpened;
        };

        /**
         * Toggle the display of the preVisitDate's datepicker
         */
        self.toggleDatePreVisit = function toggleDatePreVisit() {
            self.isDatePickerPreVisitOpened = !self.isDatePickerPreVisitOpened;
        };

        self.toggleFormation = (formation) => {
            self.formations.map(f => {
                if (f.id === formation.id){
                    f.selected = true;
                    self.cpi.formation = formation.id;
                } else {
                    f.selected = false;
                }
            });
        };

        /**
         * Get the month label
         * @param  {int} monthNumber
         * @return {String}
         */
        self.getMonth = function getMonth(monthNumber) {
            return moment()
                .month(monthNumber)
                .format('MMMM');
        };

        function _getNbBF() {
            var nbBF = 0;
            for (var i = 0; i < self.order.tills.length; i++) {
                if (self.order.tills[i].tillType.code === 'BF') {
                    nbBF += self.order.tills[i].nbTills;
                }
            }
            return nbBF;
        }

        self.nbBF = _getNbBF();

        self.changeWishedInstallationDate = function changeWishedInstallationDate() {
            _verifWishedInstallationDate();
        };

        function _verifWishedInstallationDate() {
            var monthDateInstallation = moment(self.order.dateInstallation).format('MM');
            var yearDateInstallation = moment(self.order.dateInstallation).format('YYYY');
            var monthWishedInstallationDate = moment(self.cpi.wishedInstallationDate).format('MM');
            var yearWishedInstallationDate = moment(self.cpi.wishedInstallationDate).format('YYYY');
            var sameMonth = monthDateInstallation === monthWishedInstallationDate;
            var sameYear = yearDateInstallation === yearWishedInstallationDate;

            if (!sameMonth && !sameYear) {
                Notification.warning(
                    "Le mois et l'année sélectionnés sont différents de ceux renseignés lors de la définition du contrat"
                );
            }
            else if (!sameMonth) {
                Notification.warning(
                    'Le mois sélectionné est différent de celui renseigné lors de la définition du contrat'
                );
            }
            else if (!sameYear) {
                Notification.warning(
                    "L'année sélectionnée est différente de celle renseignée lors de la définition du contrat"
                );
            }
        }

        /**
         * Update the odeolis fields
         */
        self.updateOdeolis = function updateOdeolis() {
            if (self.order.contract.scenarioType.code === 'EXTENSION' && self.isCreation) {
                self.cpi.isOdeolis = true;
                self.cpi.odeolisReason = 'Extension: Ajout de caisse';
                return;
            }

            // if(self.cpi.actualEquipment === 'Non informatisé') {
            // self.cpi.isOdeolis = true;
            // self.cpi.odeolisReason = 'Client non informatisé';
            // return;
            // }

            if (self.order.contract.scenarioType.code === 'CONQUETE' && self.isCreation) {
                if (self.nbBF > 2) {
                    self.cpi.isOdeolis = true;
                    self.cpi.odeolisReason = 'Conquête 3 caisses et +';
                    return;
                }
            }

            return;
        };

        self.isRecoveryAvailable = function isRecoveryAvailable() {
            if (!self.cpi.actualEquipment) {
                return false;
            }

            if (
                self.supplier.isPress ||
                self.supplier.isTobacco ||
                self.supplier.isBookShop ||
                self.supplier.isStationery ||
                self.supplier.isTaxable
            ) {
                return true;
            }

            return false;
        };

        self.setRecovery = function setRecovery() {
            if (self.isRecoveryAvailable()) {
                self.cpi.isRecovery = true;
                self.cpi.isPress = self.supplier.isPress;
                self.cpi.isTobacco = self.supplier.isTobacco;
                self.cpi.isBookShop = self.supplier.isBookShop;
                self.cpi.isStationery = self.supplier.isStationery;
                self.cpi.isTaxable = self.supplier.isTaxable;
            }
            else {
                self.cpi.isRecovery = false;
                self.cpi.isPress = false;
                self.cpi.isTobacco = false;
                self.cpi.isBookShop = false;
                self.cpi.isStationery = false;
                self.cpi.isTaxable = false;
            }
        };

        /**
         * Update the supplier
         */
        self.updateSupplier = function updateSupplier() {
            for (var i = 0; i < self.suppliers.length; i++) {
                if (self.suppliers[i].name === self.cpi.actualEquipment) {
                    self.supplier = self.suppliers[i];
                }
            }
            self.updateOdeolis();
            // self.setRecovery();
        };

        self.updateSupplier();

        /**
         * Send the CPI to the webservice
         */
        self.saveCPI = function saveCPI() {
            if (!self.cpi.isRecovery) {
                self.cpi.isPress = false;
                self.cpi.isTobacco = false;
                self.cpi.isBookShop = false;
                self.cpi.isStationery = false;
                self.cpi.isTaxable = false;
            }

            // if no pre-visit, whisehdPreVisitDate must be null
            if (!self.cpi.isOdeolis) {
                self.cpi.odeolisReason = '';
                self.cpi.wishedPreVisitDate = null;
            }

            if (self.checkCpiBeforeSave()) {
                cpiService
                    .save(self.order)
                    .then(function() {
                        Notification.success('Le CPI a été enregistré');
                    })
                    .catch(function(res) {
                        Notification.error(
                            'Une erreur est survenue ' + (res.data && res.data.message ? ': ' + res.data.message : '')
                        );
                        $log.error(res);
                    });
            }
        };

        /**
         * Check fields of cpi before sending to bdd
         * @returns {boolean}
         */
        self.checkCpiBeforeSave = function checkCpiBeforeSave() {
            // Check pre-visit date
            if (self.cpi.isOdeolis && self.cpi.wishedPreVisitDate === null) {
                Notification.error("Le CPI ne peut pas être enregistré, merci d'indiquer une date de pré-visite");
                return false;
            }

            // Check wishedInstallationDate
            if (self.cpi.wishedInstallationDate === null) {
                Notification.error(
                    "Le CPI ne peut pas être enregistré, merci d'indiquer une date d'installation souhaitée"
                );
                return false;
            }

            return true;
        };

        /**
         * Is the CPI published ?
         * @return {Boolean}
         */
        self.isReleased = function isReleased() {
            return self.cpi.isReleased;
        };

        /**
         * Print the CPI
         * @method printCPI
         */
        self.printCPI = function printCPI() {
            cpiService.printCPI();
        };

        self.goToOrderForm = reportRoutingService.goToOrderForm;


        return self;
    }

    CPICtrl.$inject = ['$rootScope', '$scope', 'cpiService', 'Notification', '$log', 'pricesService', 'reportRoutingService'];

    angular
        .module('app.bdc.cpi.cpiCtrl', ['ui-notification'])
        .directive('stringToInt', function() {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function(value) {
                        return value === null ? 0 : '' + value;
                    });
                    ngModel.$formatters.push(function(value) {
                        return parseInt(value);
                    });
                }
            };
        })
        .controller('CPICtrl', CPICtrl);
});
